import { ChevronRight } from "lucide-react";
import { User } from "../../../types/slice.types";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { UserDetailsOverlay } from "./UserDetailsOverlay";

export const UserPanelItems = ({ user }: { user: User }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        className="group flex items-center justify-between rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 px-5 py-4 transition-all duration-200 hover:shadow-md hover:border-primaryText dark:hover:border-primaryTextDark cursor-pointer"
        onClick={() => setOpen(true)}
      >
        <div className="flex flex-col gap-1">
          <span className="text-xs text-gray-500">
            <b>{t("User ID")}:</b> {user._id}
          </span>
          <span className="text-sm">
            <b>{t("User Name")}:</b> {user.name}
          </span>
          <span className="text-xs text-gray-500">
            <b>{t("Email")}:</b> {user.email}
          </span>
          <span className="text-xs text-gray-500">
            <b>{t("Role")}:</b> {user.role}
          </span>
        </div>

        <ChevronRight className="w-6 h-6 text-gray-400 opacity-0 group-hover:opacity-100 transition" />
      </div>

      {open && (
        <UserDetailsOverlay user={user} onClose={() => setOpen(false)} />
      )}
    </>
  );
};
